<div
  class="side-nav layout-column flex"
  [ngClass]="{ collapsed: collapsed, hidden: hidden }"
>
  <div class="top-items items layout-column flex bgc-blue-grey-800">
    <mat-nav-list class="items-nav-list">
      <mat-list-item class="logo-item" style="height: 48px">
        <div class="logo"></div>
      </mat-list-item>

      <ng-container *ngFor="let option of sidenavOptions">
        <mat-list-item
          *ngIf="isOptionVisible(option)"
          (click)="onClickOption(option.routerLink)"
          [ngClass]="{ active: active === option.routerLink }"
        >
          <mat-icon
            class="icon"
            mat-list-icon
            svgIcon="{{ option.icon }}"
          ></mat-icon>
          <span class="show-md" [ngClass]="{ collapsed: collapsed }">{{
            option.name | translate | titlecase
          }}</span>
        </mat-list-item>
      </ng-container>
    </mat-nav-list>
  </div>

  <div class="bottom-items items layout-column">
    <mat-nav-list>
      <mat-divider></mat-divider>
      <mat-list-item class="bgc-blue-grey-500" (click)="collapsed = !collapsed">
        <div fxLayout="row" fxFlex fxLayoutAlign="end">
          <mat-icon svgIcon="{{ collapsedIcon }}"></mat-icon>
        </div>
      </mat-list-item>
    </mat-nav-list>
  </div>
</div>
